import { string, object, boolean, mixed } from 'yup';
import { translate } from '../Services/translation';

const newsletterEmailSchema = object().shape({
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.email`)),
});

export {
    newsletterEmailSchema
};